module.exports = __webpack_public_path__ + "static/img/large-netflix.32b77bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/large-netflix.png
// module id = 42
// module chunks = 0